import FileSaver from 'file-saver';
import DisputeReviewedIcon from '../../assets/DisputeReviewedIcon.svg';
import DisputedIcon from '../../assets/DisputedIcon.svg';

export const exportExcel = (data:any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'scorecard_disputes');
    });
};
export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};
export const statusIcon=(rowData: any) => {
    let icon= null;
    if (rowData.disputeStatusID === 2) icon = DisputeReviewedIcon;
    else if (rowData.disputeStatusID === 1) icon = DisputedIcon;
    return icon;
}
